<script lang="ts" setup>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'

interface Props {
  listLocation: any
  oriIndustry: string
  oriLocation: string
}

const props = defineProps<Props>()
const emit = defineEmits(['update:location', 'update:industry', 'openLocation', 'openIndustry'])
const isOpen = ref(false)
const isFullscreen = ref(false)
const gicsIndustry = useGetGICS()
const totalFilter = computed(() => {
  let total = 0
  if (!isEmpty(props.oriIndustry))
    total++
  if (!isEmpty(props.oriLocation))
    total++
  return total
})

// setup GICS

onMounted(async () => {
  await nextTick()
})

function toogleFullScreen() {
  isFullscreen.value = !isFullscreen.value
}

function closeModal() {
  isOpen.value = false
}

function openModal() {
  isOpen.value = true
}
</script>

<template>
  <div class="h-full flex flex-col">
    <div :class="`${totalFilter > 0 ? 'border-primary-400 bg-[#ECE9FC] text-[#5843E5] font-semibold' : 'bg-white border-gray-200'} cursor-pointer relative pl-4 pr-6 py-1.5 rounded-md text-sm flex items-center border`" @click="openModal">
      <Icon name="mdi:filter-list" class="h-5 w-5" />
      <div v-if="totalFilter > 0" class="rounded-full text-white bg-[#5843E5] px-2 py-1.5 text-[8px] font-bold mx-1">
        {{ totalFilter }}
      </div>
      <span :class="`${totalFilter > 0 ? '' : 'ml-2'} block truncate`">Filter</span>
    </div>
    <TransitionRoot as="template" appear :show="isOpen">
      <Dialog as="div" class="relative z-100" @close="closeModal">
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div class="fixed inset-0 bg-black bg-opacity-25" />
        </TransitionChild>

        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0 scale-95"
          enter-to="opacity-100 scale-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100 scale-100"
          leave-to="opacity-0 scale-95"
        >
          <DialogPanel
            :class="[isFullscreen ? 'max-h-full min-h-full' : 'max-h-4/5 min-h-4/5 rounded-t-3xl !overflow-y-hidden']"
            class="fixed inset-x-0 bottom-0 overflow-y-auto bg-white border-t border-gray-100 rounded-t-3xl overflow-y-scroll bg-white py-4 px-4 sm:p-6 text-left align-middle shadow transition-all"
          >
            <!-- header -->
            <div class="justify-between mb-4">
              <div class="text-center" @click="toogleFullScreen()">
                <Icon name="pepicons-pop:line-x" class="w-7 h-7 mx-auto text-gray-400" />
              </div>
              <div class="text-xl font-bold pb-3.5">
                Filter
              </div>
              <hr>
            </div>

            <!-- filter location -->
            <div class="mb-10">
              <div class="flex mb-4">
                <p class="font-bold text-sm">
                  Location
                </p>
                <div class="cursor-pointer font-semibold text-[#5843E5] ml-auto text-sm" @click="emit('openLocation', true)">
                  See all
                </div>
              </div>
              <div class="flex flex-wrap gap-2">
                <span v-for="(item, idx) in props.listLocation.slice(0, 5)" :key="idx" :class="`${item.value === props.oriLocation ? 'font-semibold bg-[#ECE9FC] text-[#5843E5]' : 'bg-gray-100'} px-4 py-2 text-sm rounded-full whitespace-nowrap cursor-pointer`" @click="emit('update:location', props.oriLocation === item.value ? null : item.value)">{{ item.label }}</span>
              </div>
            </div>

            <!-- filter industries -->
            <div>
              <div class="flex mb-4">
                <p class="font-bold text-sm">
                  Industries
                </p>
                <div class="cursor-pointer font-semibold text-[#5843E5] ml-auto text-sm" @click="emit('openIndustry', true)">
                  See all
                </div>
              </div>
              <div class="flex flex-wrap gap-2">
                <span v-for="(item, idx) in gicsIndustry.slice(0, 5)" :key="idx" :class="`${item.value === props.oriIndustry ? 'font-semibold bg-[#ECE9FC] text-[#5843E5]' : 'bg-gray-100'} px-4 py-2 text-sm rounded-full whitespace-nowrap cursor-pointer`" @click="emit('update:industry', props.oriIndustry === item.value ? null : item.value)">{{ item.name }}</span>
              </div>
            </div>
          </DialogPanel>
        </TransitionChild>
      </Dialog>
    </TransitionRoot>
  </div>
</template>
